export interface IIntegrationItem {
  name: string;
  order: number;
}
export const INTEGRATIONS_LIST = [
  { name: 'AlfaCRM', order: 1},
  { name: 'ALLOSTAT', order: 2},
  { name: 'ApixDrive', order: 3},
  { name: 'BrizoCRM', order: 4},
  { name: 'Callibri', order: 5},
  { name: 'EnvyCRM', order: 6},
  { name: 'FITBASE', order: 7},
  { name: 'FreshOffice', order: 8},
  { name: 'HelloClient CRM', order: 9},
  { name: 'HOLLIHOP', order: 10},
  { name: 'imot.io', order: 11},
  { name: 'Leeloo.ai', order: 12},
  { name: 'LiveSklad CRM', order: 13},
  { name: 'MegaCRM', order: 14},
  { name: 'OneBox', order: 15},
  { name: 'Planfix', order: 16},
  { name: 'ProducerCRM', order: 17},
  { name: 'Ramex', order: 18},
  { name: 'retailCRM', order: 19},
  { name: 'S2 CRM', order: 20},
  { name: 'SalesMan CRM', order: 21},
  { name: 'SalesMax (Mawisoft)', order: 22},
  { name: 'Speech Analytics', order: 23},
  { name: 'StorVerk', order: 24},
  { name: 'SYNERGY CRM', order: 25},
  { name: 'Tezarius', order: 26},
  { name: 'UTMSTAT', order: 27},
  { name: 'UseDesk', order: 28},
  { name: 'WireCRM', order: 29},
  { name: 'Yeahdesk', order: 30},
  { name: 'YUCRM', order: 31},
  { name: 'Клиентская база', order: 32},
]
